import { Component, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface ConfirmModel {
  title: string;
  message: string;
  showCancel: boolean;
}

@Component({
    selector: 'confirm',
    templateUrl: 'confirm.component.html',
    standalone: false
})
export class ConfirmComponent
  implements ConfirmModel
{
  public title: string;
  public message: string;
  public showCancel: boolean = true;

  constructor(public bsModalRef: BsModalRef) {}

  @Output() onClose = new EventEmitter<boolean>();

  public confirm() {
    this.bsModalRef.hide();
    this.onClose.emit(true);
  }

  public cancel() {
    this.bsModalRef.hide();
    this.onClose.emit(false);
  }

  public close() {
    this.cancel();
  }
}
